import React, { Component } from "react";
import Autocomplete , { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";



const CustomAutocomplete = withStyles({
    root: {
        fontFamily: "Poppins-Regular",
        padding:"0px 0px",
        "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
          // Default transform is "translate(14px, 20px) scale(1)""
          // This lines up the label with the initial cursor position in the input
          // after changing its padding-left.
          transform: "translate(34px, 20px) scale(1);"
        }
      },
      inputRoot: {
        color: "#555",
        border:"1",
        borderColor:"#DBE1EA",
        fontFamily: "Poppins-Regular",
        fontSize:"12px",
        padding:"0px,6px",
        // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
          // Default left padding is 6px
          paddingLeft: 10
        },
        '&[class*="MuiOutlinedInput-root"]': {
            // Default left padding is 6px
            padding: "5px",
            minHeight:"37px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA"
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA"
          
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA",
          border:"1px solid",
        },
        "& input::placeholder": {
          fontSize: "14px"
        },
        "&&& $input": {
          padding: "1px"
        }
    },
    listbox:{
        fontFamily: "Poppins-Regular",
        fontSize:"12px",
    },
    popupIndicator:{
        display:"none",
    },
    tag: {
      backgroundColor: "#F1FCFF",
      borderColor:'#D9F6FD',
      border:"1px solid",
      fontFamily: "Poppins-Regular",
      fontSize:"12px",
      lineHeight:"18px",
      height: 24,
      borderRadius:"4px",
      position: "relative",
      zIndex: 0,
      "& .MuiChip-label": {
        color: "#000"
      },
      "& .MuiChip-deleteIcon": {
        color: "#d1d1d1bf",
        width:13
      },
      "&:after": {
        content: '""',
        right: 10,
        top: 6,
        height: 12,
        width: 12,
        position: "absolute",
        // backgroundColor: "white",
        zIndex: -1
      }
    }
  })(Autocomplete);

  export default CustomAutocomplete


// WEBPACK FOOTER //
// ./src/components/CustomAutocomplete.js